import { Injectable } from '@angular/core';
import { HttpParameterCodec } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class MaShipcaseService {
    private apiSpringUrl = '/spring/mashipcases';

    constructor(private http: HttpService) { }

    get(
        ownerId?: number
    ): Promise<any> {
        let url:string = '';
        if (ownerId !== undefined) {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
        } else {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        }
        return this.http.get(url);
    }

    post(
        ownerId: number,
        shipcaseCd: string,
        shipcaseTx: string,
        lengthNr: number,
        widthNr: number,
        heightNr: number,
        capacityrateNr: number,
        updprogramCd: string
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        const jsonInput = {
            ownerId: ownerId,
            shipcaseCd: shipcaseCd,
            shipcaseTx: shipcaseTx,
            lengthNr: lengthNr,
            widthNr: widthNr,
            heightNr: heightNr,
            capacityrateNr: capacityrateNr,
            updprogramCd: updprogramCd
        };
    return this.http.post(url, jsonInput);
    }

    put(
        maShipcaseId: number,
        ownerId: number,
        shipcaseCd: string,
        shipcaseTx: string,
        lengthNr: number,
        widthNr: number,
        heightNr: number,
        capacityrateNr: number,
        updprogramCd: string,
        updcounterNr: number
    ): Promise<any> {
        const targetServiceCode = '';
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${maShipcaseId}`;
        const jsonInput = {
            ownerId: ownerId,
            shipcaseCd: shipcaseCd,
            shipcaseTx: shipcaseTx,
            lengthNr: lengthNr,
            widthNr: widthNr,
            heightNr: heightNr,
            capacityrateNr: capacityrateNr,
            updprogramCd: updprogramCd,
            updcounterNr: updcounterNr
        };
        return this.http.put(url, jsonInput, targetServiceCode);
    }

    delete(
        maShipcaseId: number
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${maShipcaseId}`;
        return this.http.delete(url);
    }

}


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/mashipcase/mashipcase.service.ts